
// WhatsAppContext — Suivi du statut du worker et file d'attente des messages
import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { checkWorkerStatus, createWhatsAppListener, sendWhatsAppMessage as sendWAMessage, generateClientMsgId } from '../services/whatsapp';
import { useApp } from './AppContext';

var WhatsAppContext = createContext(null);

export function useWhatsApp() {
  return useContext(WhatsAppContext);
}

export function WhatsAppProvider({ children }) {
  var { mySocketId, user } = useApp();
  var [workerOnline, setWorkerOnline] = useState(false);
  var [pendingCount, setPendingCount] = useState(0);
  var [workerLastSeen, setWorkerLastSeen] = useState(null);
  var [flushNotification, setFlushNotification] = useState(null); // { count, timestamp }

  // Écouter les changements de statut du worker
  useEffect(function() {
    var cleanup = createWhatsAppListener(
      function onOnline(status) {
        setWorkerOnline(true);
        setWorkerLastSeen(status.lastSeen);
        setPendingCount(status.pendingCount || 0);
      },
      function onOffline(status) {
        setWorkerOnline(false);
        setWorkerLastSeen(status.lastSeen);
      },
      function onFlush(count) {
        setFlushNotification({ count: count, timestamp: Date.now() });
        setPendingCount(0);
        // Auto-effacer après 5 secondes
        setTimeout(function() { setFlushNotification(null); }, 5000);
      }
    );
    return cleanup;
  }, []);

  // Envoi d'un message WhatsApp avec store-and-forward
  var sendMessage = useCallback(async function(from, text, chatJid, isGroup) {
    var result = await sendWAMessage(from, text, user?.id, chatJid, isGroup);
    if (result.queued) {
      setPendingCount(function(c) { return c + 1; });
    }
    return result;
  }, [user?.id]);

  return (
    <WhatsAppContext.Provider value={{
      workerOnline: workerOnline,
      pendingCount: pendingCount,
      workerLastSeen: workerLastSeen,
      flushNotification: flushNotification,
      sendMessage: sendMessage,
      generateClientMsgId: generateClientMsgId,
      checkWorkerStatus: checkWorkerStatus,
    }}>
      {children}
    </WhatsAppContext.Provider>
  );
}
